// extracted by mini-css-extract-plugin
export var inlineSideCard = "RightSideWrapper-module__inlineSideCard___mwdV-";
export var portalCard = "RightSideWrapper-module__portalCard___9dRPn";
export var sideCard = "RightSideWrapper-module__sideCard___Ewvb5";
export var wrapper = "RightSideWrapper-module__wrapper___SOj6K";